export const kicksets = {
  SRS: {
    kicks: {
      "01": [
        [-1, 0],
        [-1, -1],
        [0, 2],
        [-1, 2]
      ],
      10: [
        [1, 0],
        [1, 1],
        [0, -2],
        [1, -2]
      ],
      12: [
        [1, 0],
        [1, 1],
        [0, -2],
        [1, -2]
      ],
      21: [
        [-1, 0],
        [-1, -1],
        [0, 2],
        [-1, 2]
      ],
      23: [
        [1, 0],
        [1, -1],
        [0, 2],
        [1, 2]
      ],
      32: [
        [-1, 0],
        [-1, 1],
        [0, -2],
        [-1, -2]
      ],
      30: [
        [-1, 0],
        [-1, 1],
        [0, -2],
        [-1, -2]
      ],
      "03": [
        [1, 0],
        [1, -1],
        [0, 2],
        [1, 2]
      ],
      "02": [
        [0, -1],
        [1, -1],
        [-1, -1],
        [1, 0],
        [-1, 0]
      ],
      13: [
        [1, 0],
        [1, -2],
        [1, -1],
        [0, -2],
        [0, -1]
      ],
      20: [
        [0, 1],
        [-1, 1],
        [1, 1],
        [-1, 0],
        [1, 0]
      ],
      31: [
        [-1, 0],
        [-1, -2],
        [-1, -1],
        [0, -2],
        [0, -1]
      ]
    },
    i_kicks: {
      "01": [
        [-2, 0],
        [1, 0],
        [-2, 1],
        [1, -2]
      ],
      10: [
        [2, 0],
        [-1, 0],
        [2, -1],
        [-1, 2]
      ],
      12: [
        [-1, 0],
        [2, 0],
        [-1, -2],
        [2, 1]
      ],
      21: [
        [1, 0],
        [-2, 0],
        [1, 2],
        [-2, -1]
      ],
      23: [
        [2, 0],
        [-1, 0],
        [2, -1],
        [-1, 2]
      ],
      32: [
        [-2, 0],
        [1, 0],
        [-2, 1],
        [1, -2]
      ],
      30: [
        [1, 0],
        [-2, 0],
        [1, 2],
        [-2, -1]
      ],
      "03": [
        [-1, 0],
        [2, 0],
        [-1, -2],
        [2, 1]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    i2_kicks: {
      "01": [
        [0, -1],
        [-1, 0],
        [-1, -1]
      ],
      10: [
        [0, 1],
        [1, 0],
        [1, 1]
      ],
      12: [
        [1, 0],
        [0, -1],
        [1, 0]
      ],
      21: [
        [-1, 0],
        [0, 1],
        [-1, 0]
      ],
      23: [
        [0, 1],
        [1, 0],
        [1, -1]
      ],
      32: [
        [0, -1],
        [-1, 0],
        [-1, 1]
      ],
      30: [
        [-1, 0],
        [0, 1],
        [-1, 2]
      ],
      "03": [
        [1, 0],
        [0, -1],
        [1, -2]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    i3_kicks: {
      "01": [
        [1, 0],
        [-1, 0],
        [0, 1],
        [0, -1]
      ],
      10: [
        [-1, 0],
        [1, 0],
        [0, -1],
        [0, 1]
      ],
      12: [
        [1, 0],
        [-1, 0],
        [0, -2],
        [0, 2]
      ],
      21: [
        [-1, 0],
        [1, 0],
        [0, 2],
        [0, -2]
      ],
      23: [
        [-1, 0],
        [1, 0],
        [0, 1],
        [0, -1]
      ],
      32: [
        [1, 0],
        [-1, 0],
        [0, -1],
        [0, 1]
      ],
      30: [
        [-1, 0],
        [1, 0],
        [0, 0],
        [0, 0]
      ],
      "03": [
        [1, 0],
        [-1, 0],
        [0, 0],
        [0, 0]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    l3_kicks: {
      "01": [
        [-1, 0],
        [1, 0]
      ],
      10: [
        [1, 0],
        [-1, 0]
      ],
      12: [
        [0, -1],
        [0, 1]
      ],
      21: [
        [0, 1],
        [0, -1]
      ],
      23: [
        [1, 0],
        [-1, 0]
      ],
      32: [
        [-1, 0],
        [1, 0]
      ],
      30: [
        [0, 1],
        [0, -1]
      ],
      "03": [
        [0, -1],
        [0, 1]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    i5_kicks: {
      "01": [
        [-2, 0],
        [2, 0],
        [-2, 1],
        [2, -2]
      ],
      10: [
        [2, 0],
        [-2, 0],
        [2, -1],
        [-2, 2]
      ],
      12: [
        [-2, 0],
        [2, 0],
        [-2, -2],
        [2, 1]
      ],
      21: [
        [2, 0],
        [-2, 0],
        [2, 2],
        [-2, -1]
      ],
      23: [
        [2, 0],
        [-2, 0],
        [2, -1],
        [-2, 2]
      ],
      32: [
        [-2, 0],
        [2, 0],
        [-2, 1],
        [2, -2]
      ],
      30: [
        [2, 0],
        [-2, 0],
        [2, 2],
        [-2, -1]
      ],
      "03": [
        [-2, 0],
        [2, 0],
        [-2, -2],
        [2, 1]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    oo_kicks: {
      "01": [
        [0, -1],
        [-1, -1],
        [0, 1],
        [-1, 1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      10: [
        [1, 0],
        [0, -1],
        [1, 1],
        [1, -1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      12: [
        [-1, 0],
        [0, -1],
        [-1, 1],
        [-1, -1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      21: [
        [0, -1],
        [1, -1],
        [0, 1],
        [1, 1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      23: [
        [0, -1],
        [-1, -1],
        [0, 1],
        [-1, 1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      32: [
        [1, 0],
        [0, -1],
        [1, 1],
        [1, -1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      30: [
        [-1, 0],
        [0, -1],
        [-1, 1],
        [-1, -1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      "03": [
        [0, -1],
        [1, -1],
        [0, 1],
        [1, 1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      "02": [[0, -1]],
      13: [[1, 0]],
      20: [[0, 1]],
      31: [[-1, 0]]
    },
    additional_offsets: {},
    spawn_rotation: {},
    color_overrides: {},
    preview_overrides: {}
  },
  "SRS+": {
    kicks: {
      "01": [
        [-1, 0],
        [-1, -1],
        [0, 2],
        [-1, 2]
      ],
      10: [
        [1, 0],
        [1, 1],
        [0, -2],
        [1, -2]
      ],
      12: [
        [1, 0],
        [1, 1],
        [0, -2],
        [1, -2]
      ],
      21: [
        [-1, 0],
        [-1, -1],
        [0, 2],
        [-1, 2]
      ],
      23: [
        [1, 0],
        [1, -1],
        [0, 2],
        [1, 2]
      ],
      32: [
        [-1, 0],
        [-1, 1],
        [0, -2],
        [-1, -2]
      ],
      30: [
        [-1, 0],
        [-1, 1],
        [0, -2],
        [-1, -2]
      ],
      "03": [
        [1, 0],
        [1, -1],
        [0, 2],
        [1, 2]
      ],
      "02": [
        [0, -1],
        [1, -1],
        [-1, -1],
        [1, 0],
        [-1, 0]
      ],
      13: [
        [1, 0],
        [1, -2],
        [1, -1],
        [0, -2],
        [0, -1]
      ],
      20: [
        [0, 1],
        [-1, 1],
        [1, 1],
        [-1, 0],
        [1, 0]
      ],
      31: [
        [-1, 0],
        [-1, -2],
        [-1, -1],
        [0, -2],
        [0, -1]
      ]
    },
    i_kicks: {
      "01": [
        [1, 0],
        [-2, 0],
        [-2, 1],
        [1, -2]
      ],
      10: [
        [-1, 0],
        [2, 0],
        [-1, 2],
        [2, -1]
      ],
      12: [
        [-1, 0],
        [2, 0],
        [-1, -2],
        [2, 1]
      ],
      21: [
        [-2, 0],
        [1, 0],
        [-2, -1],
        [1, 2]
      ],
      23: [
        [2, 0],
        [-1, 0],
        [2, -1],
        [-1, 2]
      ],
      32: [
        [1, 0],
        [-2, 0],
        [1, -2],
        [-2, 1]
      ],
      30: [
        [1, 0],
        [-2, 0],
        [1, 2],
        [-2, -1]
      ],
      "03": [
        [-1, 0],
        [2, 0],
        [2, 1],
        [-1, -2]
      ],
      "02": [[0, -1]],
      13: [[1, 0]],
      20: [[0, 1]],
      31: [[-1, 0]]
    },
    i2_kicks: {
      "01": [
        [0, -1],
        [-1, 0],
        [-1, -1]
      ],
      10: [
        [0, 1],
        [1, 0],
        [1, 1]
      ],
      12: [
        [1, 0],
        [0, -1],
        [1, 0]
      ],
      21: [
        [-1, 0],
        [0, 1],
        [-1, 0]
      ],
      23: [
        [0, 1],
        [1, 0],
        [1, -1]
      ],
      32: [
        [0, -1],
        [-1, 0],
        [-1, 1]
      ],
      30: [
        [-1, 0],
        [0, 1],
        [-1, 2]
      ],
      "03": [
        [1, 0],
        [0, -1],
        [1, -2]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    i3_kicks: {
      "01": [
        [1, 0],
        [-1, 0],
        [0, 1],
        [0, -1]
      ],
      10: [
        [-1, 0],
        [1, 0],
        [0, -1],
        [0, 1]
      ],
      12: [
        [1, 0],
        [-1, 0],
        [0, -2],
        [0, 2]
      ],
      21: [
        [-1, 0],
        [1, 0],
        [0, 2],
        [0, -2]
      ],
      23: [
        [-1, 0],
        [1, 0],
        [0, 1],
        [0, -1]
      ],
      32: [
        [1, 0],
        [-1, 0],
        [0, -1],
        [0, 1]
      ],
      30: [
        [-1, 0],
        [1, 0],
        [0, 0],
        [0, 0]
      ],
      "03": [
        [1, 0],
        [-1, 0],
        [0, 0],
        [0, 0]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    l3_kicks: {
      "01": [
        [-1, 0],
        [1, 0]
      ],
      10: [
        [1, 0],
        [-1, 0]
      ],
      12: [
        [0, -1],
        [0, 1]
      ],
      21: [
        [0, 1],
        [0, -1]
      ],
      23: [
        [1, 0],
        [-1, 0]
      ],
      32: [
        [-1, 0],
        [1, 0]
      ],
      30: [
        [0, 1],
        [0, -1]
      ],
      "03": [
        [0, -1],
        [0, 1]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    i5_kicks: {
      "01": [
        [-2, 0],
        [2, 0],
        [-2, 1],
        [2, -2]
      ],
      10: [
        [2, 0],
        [-2, 0],
        [2, -1],
        [-2, 2]
      ],
      12: [
        [-2, 0],
        [2, 0],
        [-2, -2],
        [2, 1]
      ],
      21: [
        [2, 0],
        [-2, 0],
        [2, 2],
        [-2, -1]
      ],
      23: [
        [2, 0],
        [-2, 0],
        [2, -1],
        [-2, 2]
      ],
      32: [
        [-2, 0],
        [2, 0],
        [-2, 1],
        [2, -2]
      ],
      30: [
        [2, 0],
        [-2, 0],
        [2, 2],
        [-2, -1]
      ],
      "03": [
        [-2, 0],
        [2, 0],
        [-2, -2],
        [2, 1]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    oo_kicks: {
      "01": [
        [0, -1],
        [-1, -1],
        [0, 1],
        [-1, 1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      10: [
        [1, 0],
        [0, -1],
        [1, 1],
        [1, -1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      12: [
        [-1, 0],
        [0, -1],
        [-1, 1],
        [-1, -1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      21: [
        [0, -1],
        [1, -1],
        [0, 1],
        [1, 1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      23: [
        [0, -1],
        [-1, -1],
        [0, 1],
        [-1, 1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      32: [
        [1, 0],
        [0, -1],
        [1, 1],
        [1, -1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      30: [
        [-1, 0],
        [0, -1],
        [-1, 1],
        [-1, -1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      "03": [
        [0, -1],
        [1, -1],
        [0, 1],
        [1, 1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      "02": [[0, -1]],
      13: [[1, 0]],
      20: [[0, 1]],
      31: [[-1, 0]]
    },
    additional_offsets: {},
    spawn_rotation: {},
    color_overrides: {},
    preview_overrides: {}
  },
  "SRS-X": {
    kicks: {
      "01": [
        [-1, 0],
        [-1, -1],
        [0, 2],
        [-1, 2]
      ],
      10: [
        [1, 0],
        [1, 1],
        [0, -2],
        [1, -2]
      ],
      12: [
        [1, 0],
        [1, 1],
        [0, -2],
        [1, -2]
      ],
      21: [
        [-1, 0],
        [-1, -1],
        [0, 2],
        [-1, 2]
      ],
      23: [
        [1, 0],
        [1, -1],
        [0, 2],
        [1, 2]
      ],
      32: [
        [-1, 0],
        [-1, 1],
        [0, -2],
        [-1, -2]
      ],
      30: [
        [-1, 0],
        [-1, 1],
        [0, -2],
        [-1, -2]
      ],
      "03": [
        [1, 0],
        [1, -1],
        [0, 2],
        [1, 2]
      ],
      "02": [
        [1, 0],
        [2, 0],
        [1, 1],
        [2, 1],
        [-1, 0],
        [-2, 0],
        [-1, 1],
        [-2, 1],
        [0, -1],
        [3, 0],
        [-3, 0]
      ],
      13: [
        [0, 1],
        [0, 2],
        [-1, 1],
        [-1, 2],
        [0, -1],
        [0, -2],
        [-1, -1],
        [-1, -2],
        [1, 0],
        [0, 3],
        [0, -3]
      ],
      20: [
        [-1, 0],
        [-2, 0],
        [-1, -1],
        [-2, -1],
        [1, 0],
        [2, 0],
        [1, -1],
        [2, -1],
        [0, 1],
        [-3, 0],
        [3, 0]
      ],
      31: [
        [0, 1],
        [0, 2],
        [1, 1],
        [1, 2],
        [0, -1],
        [0, -2],
        [1, -1],
        [1, -2],
        [-1, 0],
        [0, 3],
        [0, -3]
      ]
    },
    i_kicks: {
      "01": [
        [-2, 0],
        [1, 0],
        [-2, 1],
        [1, -2]
      ],
      10: [
        [2, 0],
        [-1, 0],
        [2, -1],
        [-1, 2]
      ],
      12: [
        [-1, 0],
        [2, 0],
        [-1, -2],
        [2, 1]
      ],
      21: [
        [1, 0],
        [-2, 0],
        [1, 2],
        [-2, -1]
      ],
      23: [
        [2, 0],
        [-1, 0],
        [2, -1],
        [-1, 2]
      ],
      32: [
        [-2, 0],
        [1, 0],
        [-2, 1],
        [1, -2]
      ],
      30: [
        [1, 0],
        [-2, 0],
        [1, 2],
        [-2, -1]
      ],
      "03": [
        [-1, 0],
        [2, 0],
        [-1, -2],
        [2, 1]
      ],
      "02": [
        [-1, 0],
        [-2, 0],
        [1, 0],
        [2, 0],
        [0, 1]
      ],
      13: [
        [0, 1],
        [0, 2],
        [0, -1],
        [0, -2],
        [-1, 0]
      ],
      20: [
        [1, 0],
        [2, 0],
        [-1, 0],
        [-2, 0],
        [0, -1]
      ],
      31: [
        [0, 1],
        [0, 2],
        [0, -1],
        [0, -2],
        [1, 0]
      ]
    },
    i2_kicks: {
      "01": [
        [0, -1],
        [-1, 0],
        [-1, -1]
      ],
      10: [
        [0, 1],
        [1, 0],
        [1, 1]
      ],
      12: [
        [1, 0],
        [0, -1],
        [1, 0]
      ],
      21: [
        [-1, 0],
        [0, 1],
        [-1, 0]
      ],
      23: [
        [0, 1],
        [1, 0],
        [1, -1]
      ],
      32: [
        [0, -1],
        [-1, 0],
        [-1, 1]
      ],
      30: [
        [-1, 0],
        [0, 1],
        [-1, 2]
      ],
      "03": [
        [1, 0],
        [0, -1],
        [1, -2]
      ],
      "02": [
        [-1, 0],
        [-2, 0],
        [1, 0],
        [2, 0],
        [0, 1]
      ],
      13: [
        [0, 1],
        [0, 2],
        [0, -1],
        [0, -2],
        [-1, 0]
      ],
      20: [
        [1, 0],
        [2, 0],
        [-1, 0],
        [-2, 0],
        [0, -1]
      ],
      31: [
        [0, 1],
        [0, 2],
        [0, -1],
        [0, -2],
        [1, 0]
      ]
    },
    i3_kicks: {
      "01": [
        [1, 0],
        [-1, 0],
        [0, 1],
        [0, -1]
      ],
      10: [
        [-1, 0],
        [1, 0],
        [0, -1],
        [0, 1]
      ],
      12: [
        [1, 0],
        [-1, 0],
        [0, -2],
        [0, 2]
      ],
      21: [
        [-1, 0],
        [1, 0],
        [0, 2],
        [0, -2]
      ],
      23: [
        [-1, 0],
        [1, 0],
        [0, 1],
        [0, -1]
      ],
      32: [
        [1, 0],
        [-1, 0],
        [0, -1],
        [0, 1]
      ],
      30: [
        [-1, 0],
        [1, 0],
        [0, 0],
        [0, 0]
      ],
      "03": [
        [1, 0],
        [-1, 0],
        [0, 0],
        [0, 0]
      ],
      "02": [
        [1, 0],
        [2, 0],
        [1, 1],
        [2, 1],
        [-1, 0],
        [-2, 0],
        [-1, 1],
        [-2, 1],
        [0, -1],
        [3, 0],
        [-3, 0]
      ],
      13: [
        [0, 1],
        [0, 2],
        [-1, 1],
        [-1, 2],
        [0, -1],
        [0, -2],
        [-1, -1],
        [-1, -2],
        [1, 0],
        [0, 3],
        [0, -3]
      ],
      20: [
        [-1, 0],
        [-2, 0],
        [-1, -1],
        [-2, -1],
        [1, 0],
        [2, 0],
        [1, -1],
        [2, -1],
        [0, 1],
        [-3, 0],
        [3, 0]
      ],
      31: [
        [0, 1],
        [0, 2],
        [1, 1],
        [1, 2],
        [0, -1],
        [0, -2],
        [1, -1],
        [1, -2],
        [-1, 0],
        [0, 3],
        [0, -3]
      ]
    },
    l3_kicks: {
      "01": [
        [-1, 0],
        [1, 0]
      ],
      10: [
        [1, 0],
        [-1, 0]
      ],
      12: [
        [0, -1],
        [0, 1]
      ],
      21: [
        [0, 1],
        [0, -1]
      ],
      23: [
        [1, 0],
        [-1, 0]
      ],
      32: [
        [-1, 0],
        [1, 0]
      ],
      30: [
        [0, 1],
        [0, -1]
      ],
      "03": [
        [0, -1],
        [0, 1]
      ],
      "02": [
        [1, 0],
        [2, 0],
        [1, 1],
        [2, 1],
        [-1, 0],
        [-2, 0],
        [-1, 1],
        [-2, 1],
        [0, -1],
        [3, 0],
        [-3, 0]
      ],
      13: [
        [0, 1],
        [0, 2],
        [-1, 1],
        [-1, 2],
        [0, -1],
        [0, -2],
        [-1, -1],
        [-1, -2],
        [1, 0],
        [0, 3],
        [0, -3]
      ],
      20: [
        [-1, 0],
        [-2, 0],
        [-1, -1],
        [-2, -1],
        [1, 0],
        [2, 0],
        [1, -1],
        [2, -1],
        [0, 1],
        [-3, 0],
        [3, 0]
      ],
      31: [
        [0, 1],
        [0, 2],
        [1, 1],
        [1, 2],
        [0, -1],
        [0, -2],
        [1, -1],
        [1, -2],
        [-1, 0],
        [0, 3],
        [0, -3]
      ]
    },
    i5_kicks: {
      "01": [
        [-2, 0],
        [2, 0],
        [-2, 1],
        [2, -2]
      ],
      10: [
        [2, 0],
        [-2, 0],
        [2, -1],
        [-2, 2]
      ],
      12: [
        [-2, 0],
        [2, 0],
        [-2, -2],
        [2, 1]
      ],
      21: [
        [2, 0],
        [-2, 0],
        [2, 2],
        [-2, -1]
      ],
      23: [
        [2, 0],
        [-2, 0],
        [2, -1],
        [-2, 2]
      ],
      32: [
        [-2, 0],
        [2, 0],
        [-2, 1],
        [2, -2]
      ],
      30: [
        [2, 0],
        [-2, 0],
        [2, 2],
        [-2, -1]
      ],
      "03": [
        [-2, 0],
        [2, 0],
        [-2, -2],
        [2, 1]
      ],
      "02": [
        [1, 0],
        [2, 0],
        [1, 1],
        [2, 1],
        [-1, 0],
        [-2, 0],
        [-1, 1],
        [-2, 1],
        [0, -1],
        [3, 0],
        [-3, 0]
      ],
      13: [
        [0, 1],
        [0, 2],
        [-1, 1],
        [-1, 2],
        [0, -1],
        [0, -2],
        [-1, -1],
        [-1, -2],
        [1, 0],
        [0, 3],
        [0, -3]
      ],
      20: [
        [-1, 0],
        [-2, 0],
        [-1, -1],
        [-2, -1],
        [1, 0],
        [2, 0],
        [1, -1],
        [2, -1],
        [0, 1],
        [-3, 0],
        [3, 0]
      ],
      31: [
        [0, 1],
        [0, 2],
        [1, 1],
        [1, 2],
        [0, -1],
        [0, -2],
        [1, -1],
        [1, -2],
        [-1, 0],
        [0, 3],
        [0, -3]
      ]
    },
    oo_kicks: {
      "01": [
        [0, -1],
        [-1, -1],
        [0, 1],
        [-1, 1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      10: [
        [1, 0],
        [0, -1],
        [1, 1],
        [1, -1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      12: [
        [-1, 0],
        [0, -1],
        [-1, 1],
        [-1, -1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      21: [
        [0, -1],
        [1, -1],
        [0, 1],
        [1, 1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      23: [
        [0, -1],
        [-1, -1],
        [0, 1],
        [-1, 1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      32: [
        [1, 0],
        [0, -1],
        [1, 1],
        [1, -1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      30: [
        [-1, 0],
        [0, -1],
        [-1, 1],
        [-1, -1],
        [1, 0],
        [1, -1],
        [1, 1]
      ],
      "03": [
        [0, -1],
        [1, -1],
        [0, 1],
        [1, 1],
        [-1, 0],
        [-1, -1],
        [-1, 1]
      ],
      "02": [[0, -1]],
      13: [[1, 0]],
      20: [[0, 1]],
      31: [[-1, 0]]
    },
    additional_offsets: {},
    spawn_rotation: {},
    color_overrides: {},
    preview_overrides: {}
  },
  "TETRA-X": {
    kicks: {
      "01": [
        [0, 1],
        [-1, 0],
        [1, 0],
        [-1, 1],
        [1, 1],
        [0, -1],
        [-1, -1],
        [1, -1]
      ],
      10: [
        [0, 1],
        [1, 0],
        [-1, 0],
        [1, 1],
        [-1, 1],
        [0, -1],
        [1, -1],
        [-1, -1]
      ],
      12: [
        [0, 1],
        [-1, 0],
        [1, 0],
        [-1, 1],
        [1, 1],
        [0, -1],
        [-1, -1],
        [1, -1]
      ],
      21: [
        [0, 1],
        [1, 0],
        [-1, 0],
        [1, 1],
        [-1, 1],
        [0, -1],
        [1, -1],
        [-1, -1]
      ],
      23: [
        [0, 1],
        [-1, 0],
        [1, 0],
        [-1, 1],
        [1, 1],
        [0, -1],
        [-1, -1],
        [1, -1]
      ],
      32: [
        [0, 1],
        [1, 0],
        [-1, 0],
        [1, 1],
        [-1, 1],
        [0, -1],
        [1, -1],
        [-1, -1]
      ],
      30: [
        [0, 1],
        [-1, 0],
        [1, 0],
        [-1, 1],
        [1, 1],
        [0, -1],
        [-1, -1],
        [1, -1]
      ],
      "03": [
        [0, 1],
        [1, 0],
        [-1, 0],
        [1, 1],
        [-1, 1],
        [0, -1],
        [1, -1],
        [-1, -1]
      ],
      "02": [
        [0, 1],
        [0, -1],
        [-1, 0],
        [1, 0]
      ],
      13: [
        [0, 1],
        [0, -1],
        [-1, 0],
        [1, 0]
      ],
      20: [
        [0, 1],
        [0, -1],
        [-1, 0],
        [1, 0]
      ],
      31: [
        [0, 1],
        [0, -1],
        [-1, 0],
        [1, 0]
      ]
    },
    i_kicks: {
      "01": [
        [0, -1],
        [0, -2],
        [0, 1],
        [1, -1],
        [-1, -1],
        [1, -2],
        [-1, -2]
      ],
      10: [
        [0, -1],
        [0, -2],
        [0, 1],
        [-1, 0],
        [1, 0],
        [2, 0]
      ],
      12: [
        [0, -1],
        [0, -2],
        [0, 1],
        [-1, 0],
        [1, 0],
        [2, 0]
      ],
      21: [
        [0, 1],
        [0, 2],
        [0, -1],
        [-1, 1],
        [1, 1],
        [-1, 2],
        [1, 2]
      ],
      23: [
        [0, 1],
        [0, 2],
        [0, -1],
        [1, 1],
        [-1, 1],
        [1, 2],
        [-1, 2]
      ],
      32: [
        [0, -1],
        [0, -2],
        [0, 1],
        [1, 0],
        [-1, 0],
        [-2, 0]
      ],
      30: [
        [0, -1],
        [0, -2],
        [0, 1],
        [1, 0],
        [-1, 0],
        [-2, 0]
      ],
      "03": [
        [0, -1],
        [0, -2],
        [0, 1],
        [-1, -1],
        [1, -1],
        [-1, -2],
        [1, -2]
      ],
      "02": [
        [0, -1],
        [0, 1]
      ],
      13: [
        [0, -1],
        [0, 1]
      ],
      20: [
        [0, -1],
        [0, 1]
      ],
      31: [
        [0, -1],
        [0, 1]
      ]
    },
    additional_offsets: {},
    spawn_rotation: {},
    color_overrides: {
      i1: "l",
      i2: "l",
      i3: "l",
      l3: "o",
      i5: "l",
      l: "o",
      o: "s",
      s: "i",
      i: "l",
      oo: "s"
    },
    preview_overrides: {}
  },
  NRS: {
    kicks: {
      "01": [],
      10: [],
      12: [],
      21: [],
      23: [],
      32: [],
      30: [],
      "03": [],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    additional_offsets: {
      z: [
        [1, 1],
        [1, 0],
        [1, 0],
        [2, 0]
      ],
      l: [
        [1, 0],
        [1, 0],
        [1, 0],
        [1, 0]
      ],
      o: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0]
      ],
      s: [
        [1, 1],
        [1, 0],
        [1, 0],
        [2, 0]
      ],
      i: [
        [0, 1],
        [0, 0],
        [0, 0],
        [1, 0]
      ],
      j: [
        [1, 0],
        [1, 0],
        [1, 0],
        [1, 0]
      ],
      t: [
        [1, 0],
        [1, 0],
        [1, 0],
        [1, 0]
      ]
    },
    spawn_rotation: { z: 0, l: 2, o: 0, s: 0, i: 0, j: 2, t: 2 },
    color_overrides: {},
    preview_overrides: {
      l: [
        [0, 0, 201],
        [1, 0, 68],
        [2, 0, 124],
        [0, 1, 31]
      ],
      j: [
        [0, 0, 199],
        [1, 0, 68],
        [2, 0, 114],
        [2, 1, 31]
      ],
      t: [
        [0, 0, 199],
        [1, 0, 74],
        [2, 0, 124],
        [1, 1, 31]
      ]
    }
  },
  ARS: {
    kicks: {
      "01": [
        [1, 0],
        [-1, 0]
      ],
      10: [
        [1, 0],
        [-1, 0]
      ],
      12: [
        [1, 0],
        [-1, 0]
      ],
      21: [
        [1, 0],
        [-1, 0]
      ],
      23: [
        [1, 0],
        [-1, 0]
      ],
      32: [
        [1, 0],
        [-1, 0]
      ],
      30: [
        [1, 0],
        [-1, 0]
      ],
      "03": [
        [1, 0],
        [-1, 0]
      ],
      "02": [
        [1, 0],
        [-1, 0]
      ],
      13: [
        [1, 0],
        [-1, 0]
      ],
      20: [
        [1, 0],
        [-1, 0]
      ],
      31: [
        [1, 0],
        [-1, 0]
      ]
    },
    i_kicks: {
      "01": [],
      10: [],
      12: [],
      21: [],
      23: [],
      32: [],
      30: [],
      "03": [],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    additional_offsets: {
      i1: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0]
      ],
      z: [
        [0, 1],
        [0, 0],
        [0, 0],
        [1, 0]
      ],
      l: [
        [0, 1],
        [0, 0],
        [0, 0],
        [0, 0]
      ],
      o: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0]
      ],
      s: [
        [0, 1],
        [-1, 0],
        [0, 0],
        [0, 0]
      ],
      i: [
        [0, 0],
        [0, 0],
        [0, -1],
        [1, 0]
      ],
      j: [
        [0, 1],
        [0, 0],
        [0, 0],
        [0, 0]
      ],
      t: [
        [0, 1],
        [0, 0],
        [0, 0],
        [0, 0]
      ]
    },
    spawn_rotation: { z: 0, l: 2, o: 0, s: 0, i: 0, j: 2, t: 2 },
    color_overrides: {
      i1: "z",
      i2: "z",
      i3: "z",
      i5: "z",
      z: "s",
      s: "t",
      i: "z",
      t: "i"
    },
    preview_overrides: {
      l: [
        [0, 0, 201],
        [1, 0, 68],
        [2, 0, 124],
        [0, 1, 31]
      ],
      j: [
        [0, 0, 199],
        [1, 0, 68],
        [2, 0, 114],
        [2, 1, 31]
      ],
      t: [
        [0, 0, 199],
        [1, 0, 74],
        [2, 0, 124],
        [1, 1, 31]
      ]
    },
    center_column: {
      pieces: ["l", "j", "t"],
      rules: [
        [-1, -1],
        [0, -1],
        [1, -1],
        [-1, 0],
        [0, 0],
        [1, 0],
        [-1, 1],
        [0, 1],
        [1, 1]
      ]
    }
  },
  ASC: {
    kicks: {
      "01": [
        [-1, 0],
        [0, 1],
        [-1, 1],
        [0, 2],
        [-1, 2],
        [-2, 0],
        [-2, 1],
        [-2, 2],
        [1, 0],
        [1, 1],
        [0, -1],
        [-1, -1],
        [-2, -1],
        [1, 2],
        [2, 0],
        [0, -2],
        [-1, -2],
        [-2, -2],
        [2, 1],
        [2, 2],
        [1, -1]
      ],
      10: [
        [1, 0],
        [0, 1],
        [1, 1],
        [0, 2],
        [1, 2],
        [2, 0],
        [2, 1],
        [2, 2],
        [-1, 0],
        [-1, 1],
        [0, -1],
        [1, -1],
        [2, -1],
        [-1, 2],
        [-2, 0],
        [0, -2],
        [1, -2],
        [2, -2],
        [-2, 1],
        [-2, 2],
        [-1, -1]
      ],
      12: [
        [-1, 0],
        [0, 1],
        [-1, 1],
        [0, 2],
        [-1, 2],
        [-2, 0],
        [-2, 1],
        [-2, 2],
        [1, 0],
        [1, 1],
        [0, -1],
        [-1, -1],
        [-2, -1],
        [1, 2],
        [2, 0],
        [0, -2],
        [-1, -2],
        [-2, -2],
        [2, 1],
        [2, 2],
        [1, -1]
      ],
      21: [
        [1, 0],
        [0, 1],
        [1, 1],
        [0, 2],
        [1, 2],
        [2, 0],
        [2, 1],
        [2, 2],
        [-1, 0],
        [-1, 1],
        [0, -1],
        [1, -1],
        [2, -1],
        [-1, 2],
        [-2, 0],
        [0, -2],
        [1, -2],
        [2, -2],
        [-2, 1],
        [-2, 2],
        [-1, -1]
      ],
      23: [
        [-1, 0],
        [0, 1],
        [-1, 1],
        [0, 2],
        [-1, 2],
        [-2, 0],
        [-2, 1],
        [-2, 2],
        [1, 0],
        [1, 1],
        [0, -1],
        [-1, -1],
        [-2, -1],
        [1, 2],
        [2, 0],
        [0, -2],
        [-1, -2],
        [-2, -2],
        [2, 1],
        [2, 2],
        [1, -1]
      ],
      32: [
        [1, 0],
        [0, 1],
        [1, 1],
        [0, 2],
        [1, 2],
        [2, 0],
        [2, 1],
        [2, 2],
        [-1, 0],
        [-1, 1],
        [0, -1],
        [1, -1],
        [2, -1],
        [-1, 2],
        [-2, 0],
        [0, -2],
        [1, -2],
        [2, -2],
        [-2, 1],
        [-2, 2],
        [-1, -1]
      ],
      30: [
        [-1, 0],
        [0, 1],
        [-1, 1],
        [0, 2],
        [-1, 2],
        [-2, 0],
        [-2, 1],
        [-2, 2],
        [1, 0],
        [1, 1],
        [0, -1],
        [-1, -1],
        [-2, -1],
        [1, 2],
        [2, 0],
        [0, -2],
        [-1, -2],
        [-2, -2],
        [2, 1],
        [2, 2],
        [1, -1]
      ],
      "03": [
        [1, 0],
        [0, 1],
        [1, 1],
        [0, 2],
        [1, 2],
        [2, 0],
        [2, 1],
        [2, 2],
        [-1, 0],
        [-1, 1],
        [0, -1],
        [1, -1],
        [2, -1],
        [-1, 2],
        [-2, 0],
        [0, -2],
        [1, -2],
        [2, -2],
        [-2, 1],
        [-2, 2],
        [-1, -1]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    i_kicks: {
      "01": [
        [-1, 0],
        [0, 1],
        [-1, 1],
        [0, 2],
        [-1, 2],
        [-2, 0],
        [-2, 1],
        [-2, 2],
        [1, 0],
        [1, 1],
        [0, -1],
        [-1, -1],
        [-2, -1],
        [1, 2],
        [2, 0],
        [0, -2],
        [-1, -2],
        [-2, -2],
        [2, 1],
        [2, 2],
        [1, -1]
      ],
      10: [
        [1, 0],
        [0, 1],
        [1, 1],
        [0, 2],
        [1, 2],
        [2, 0],
        [2, 1],
        [2, 2],
        [-1, 0],
        [-1, 1],
        [0, -1],
        [1, -1],
        [2, -1],
        [-1, 2],
        [-2, 0],
        [0, -2],
        [1, -2],
        [2, -2],
        [-2, 1],
        [-2, 2],
        [-1, -1]
      ],
      12: [
        [-1, 0],
        [0, 1],
        [-1, 1],
        [0, 2],
        [-1, 2],
        [-2, 0],
        [-2, 1],
        [-2, 2],
        [1, 0],
        [1, 1],
        [0, -1],
        [-1, -1],
        [-2, -1],
        [1, 2],
        [2, 0],
        [0, -2],
        [-1, -2],
        [-2, -2],
        [2, 1],
        [2, 2],
        [1, -1]
      ],
      21: [
        [1, 0],
        [0, 1],
        [1, 1],
        [0, 2],
        [1, 2],
        [2, 0],
        [2, 1],
        [2, 2],
        [-1, 0],
        [-1, 1],
        [0, -1],
        [1, -1],
        [2, -1],
        [-1, 2],
        [-2, 0],
        [0, -2],
        [1, -2],
        [2, -2],
        [-2, 1],
        [-2, 2],
        [-1, -1]
      ],
      23: [
        [-1, 0],
        [0, 1],
        [-1, 1],
        [0, 2],
        [-1, 2],
        [-2, 0],
        [-2, 1],
        [-2, 2],
        [1, 0],
        [1, 1],
        [0, -1],
        [-1, -1],
        [-2, -1],
        [1, 2],
        [2, 0],
        [0, -2],
        [-1, -2],
        [-2, -2],
        [2, 1],
        [2, 2],
        [1, -1]
      ],
      32: [
        [1, 0],
        [0, 1],
        [1, 1],
        [0, 2],
        [1, 2],
        [2, 0],
        [2, 1],
        [2, 2],
        [-1, 0],
        [-1, 1],
        [0, -1],
        [1, -1],
        [2, -1],
        [-1, 2],
        [-2, 0],
        [0, -2],
        [1, -2],
        [2, -2],
        [-2, 1],
        [-2, 2],
        [-1, -1]
      ],
      30: [
        [-1, 0],
        [0, 1],
        [-1, 1],
        [0, 2],
        [-1, 2],
        [-2, 0],
        [-2, 1],
        [-2, 2],
        [1, 0],
        [1, 1],
        [0, -1],
        [-1, -1],
        [-2, -1],
        [1, 2],
        [2, 0],
        [0, -2],
        [-1, -2],
        [-2, -2],
        [2, 1],
        [2, 2],
        [1, -1]
      ],
      "03": [
        [1, 0],
        [0, 1],
        [1, 1],
        [0, 2],
        [1, 2],
        [2, 0],
        [2, 1],
        [2, 2],
        [-1, 0],
        [-1, 1],
        [0, -1],
        [1, -1],
        [2, -1],
        [-1, 2],
        [-2, 0],
        [0, -2],
        [1, -2],
        [2, -2],
        [-2, 1],
        [-2, 2],
        [-1, -1]
      ],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    allow_o_kick: !0,
    additional_offsets: {
      i1: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0]
      ],
      z: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0]
      ],
      l: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0]
      ],
      o: [
        [0, 0],
        [0, 1],
        [-1, 1],
        [-1, 0]
      ],
      s: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0]
      ],
      i: [
        [0, 0],
        [0, -1],
        [1, -1],
        [1, 0]
      ],
      j: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0]
      ],
      t: [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0]
      ]
    },
    color_overrides: {},
    spawn_rotation: {},
    preview_overrides: {}
  },
  none: {
    kicks: {
      "01": [],
      10: [],
      12: [],
      21: [],
      23: [],
      32: [],
      30: [],
      "03": [],
      "02": [],
      13: [],
      20: [],
      31: []
    },
    additional_offsets: {},
    color_overrides: {},
    spawn_rotation: {},
    preview_overrides: {}
  }
};

export const spinbonuses_rules = {
  none: {},
  stupid: {
    types: [
      "i1",
      "i2",
      "i3",
      "l3",
      "i5",
      "z",
      "l",
      "o",
      "s",
      "i",
      "j",
      "t",
      "oo"
    ],
    types_mini: ["t"]
  },
  all: {
    types: [
      "i1",
      "i2",
      "i3",
      "l3",
      "i5",
      "z",
      "l",
      "o",
      "s",
      "i",
      "j",
      "t",
      "oo"
    ],
    types_mini: ["t"]
  },
  "all-mini": {
    types: [
      "i1",
      "i2",
      "i3",
      "l3",
      "i5",
      "z",
      "l",
      "o",
      "s",
      "i",
      "j",
      "t",
      "oo"
    ],
    types_mini: ["t"]
  },
  "all-mini+": {
    types: [
      "i1",
      "i2",
      "i3",
      "l3",
      "i5",
      "z",
      "l",
      "o",
      "s",
      "i",
      "j",
      "t",
      "oo"
    ],
    types_mini: ["t"]
  },
  "mini-only": {
    types: [
      "i1",
      "i2",
      "i3",
      "l3",
      "i5",
      "z",
      "l",
      "o",
      "s",
      "i",
      "j",
      "t",
      "oo"
    ],
    types_mini: ["t"]
  },
  handheld: { types: ["t", "s", "z", "l", "j"], types_mini: ["t"] },
  "T-spins": { types: ["t"], types_mini: ["t"] },
  "T-spins+": {
    types: ["t"],
    types_mini: ["t"]
  }
};
export const minocolors = [
  "z",
  "l",
  "o",
  "s",
  "i",
  "j",
  "t",
  "g",
  "d",
  "gb",
  "gbd"
];

export const tetrominoes = {
  i1: {
    matrix: {
      w: 1,
      h: 1,
      dx: 0,
      dy: 1,
      data: [[[0, 0, 255]], [[0, 0, 255]], [[0, 0, 255]], [[0, 0, 255]]]
    },
    preview: { w: 1, h: 1, data: [[0, 0, 255]] },
    disallow_kick: !0
  },
  i2: {
    matrix: {
      w: 2,
      h: 2,
      dx: 0,
      dy: 1,
      data: [
        [
          [0, 0, 199],
          [1, 0, 124]
        ],
        [
          [1, 0, 241],
          [1, 1, 31]
        ],
        [
          [1, 1, 124],
          [0, 1, 199]
        ],
        [
          [0, 1, 31],
          [0, 0, 241]
        ]
      ]
    },
    preview: {
      w: 2,
      h: 1,
      data: [
        [0, 0, 199],
        [1, 0, 124]
      ]
    },
    kickset_special: "i2"
  },
  i3: {
    matrix: {
      w: 3,
      h: 3,
      dx: 1,
      dy: 1,
      data: [
        [
          [0, 1, 199],
          [1, 1, 68],
          [2, 1, 124]
        ],
        [
          [1, 0, 241],
          [1, 1, 17],
          [1, 2, 31]
        ],
        [
          [2, 1, 124],
          [1, 1, 68],
          [0, 1, 199]
        ],
        [
          [1, 2, 31],
          [1, 1, 17],
          [1, 0, 241]
        ]
      ]
    },
    preview: {
      w: 3,
      h: 1,
      data: [
        [0, 0, 199],
        [1, 0, 68],
        [2, 0, 124]
      ]
    },
    kickset_special: "i3"
  },
  l3: {
    matrix: {
      w: 2,
      h: 2,
      dx: 0,
      dy: 1,
      data: [
        [
          [0, 0, 241],
          [0, 1, 39],
          [1, 1, 124]
        ],
        [
          [1, 0, 124],
          [0, 0, 201],
          [0, 1, 31]
        ],
        [
          [1, 1, 31],
          [1, 0, 114],
          [0, 0, 199]
        ],
        [
          [0, 1, 199],
          [1, 1, 156],
          [1, 0, 241]
        ]
      ]
    },
    preview: {
      w: 2,
      h: 2,
      data: [
        [0, 0, 241],
        [0, 1, 39],
        [1, 1, 124]
      ]
    },
    kickset_special: "l3"
  },
  i5: {
    matrix: {
      w: 5,
      h: 5,
      dx: 2,
      dy: 2,
      data: [
        [
          [0, 2, 199],
          [1, 2, 68],
          [2, 2, 68],
          [3, 2, 68],
          [4, 2, 124]
        ],
        [
          [2, 0, 241],
          [2, 1, 17],
          [2, 2, 17],
          [2, 3, 17],
          [2, 4, 31]
        ],
        [
          [4, 2, 124],
          [3, 2, 68],
          [2, 2, 68],
          [1, 2, 68],
          [0, 2, 199]
        ],
        [
          [2, 4, 31],
          [2, 3, 17],
          [2, 2, 17],
          [2, 1, 17],
          [2, 0, 241]
        ]
      ]
    },
    preview: {
      w: 5,
      h: 1,
      data: [
        [0, 0, 199],
        [1, 0, 68],
        [2, 0, 68],
        [3, 0, 68],
        [4, 0, 124]
      ]
    },
    kickset_special: "i5"
  },
  z: {
    matrix: {
      w: 3,
      h: 3,
      dx: 1,
      dy: 1,
      data: [
        [
          [0, 0, 199],
          [1, 0, 114],
          [1, 1, 39],
          [2, 1, 124]
        ],
        [
          [2, 0, 241],
          [2, 1, 156],
          [1, 1, 201],
          [1, 2, 31]
        ],
        [
          [2, 2, 124],
          [1, 2, 39],
          [1, 1, 114],
          [0, 1, 199]
        ],
        [
          [0, 2, 31],
          [0, 1, 201],
          [1, 1, 156],
          [1, 0, 241]
        ]
      ]
    },
    preview: {
      w: 3,
      h: 2,
      data: [
        [0, 0, 199],
        [1, 0, 114],
        [1, 1, 39],
        [2, 1, 124]
      ]
    }
  },
  l: {
    matrix: {
      w: 3,
      h: 3,
      dx: 1,
      dy: 1,
      data: [
        [
          [2, 0, 241],
          [0, 1, 199],
          [1, 1, 68],
          [2, 1, 156]
        ],
        [
          [2, 2, 124],
          [1, 0, 241],
          [1, 1, 17],
          [1, 2, 39]
        ],
        [
          [0, 2, 31],
          [2, 1, 124],
          [1, 1, 68],
          [0, 1, 201]
        ],
        [
          [0, 0, 199],
          [1, 2, 31],
          [1, 1, 17],
          [1, 0, 114]
        ]
      ]
    },
    preview: {
      w: 3,
      h: 2,
      data: [
        [2, 0, 241],
        [0, 1, 199],
        [1, 1, 68],
        [2, 1, 156]
      ]
    }
  },
  o: {
    matrix: {
      w: 2,
      h: 2,
      dx: 0,
      dy: 1,
      data: [
        [
          [0, 0, 193],
          [1, 0, 112],
          [0, 1, 7],
          [1, 1, 28]
        ],
        [
          [1, 0, 112],
          [1, 1, 28],
          [0, 0, 193],
          [0, 1, 7]
        ],
        [
          [1, 1, 28],
          [0, 1, 7],
          [1, 0, 112],
          [0, 0, 193]
        ],
        [
          [0, 1, 7],
          [0, 0, 193],
          [1, 1, 28],
          [1, 0, 112]
        ]
      ]
    },
    preview: {
      w: 2,
      h: 2,
      data: [
        [0, 0, 193],
        [1, 0, 112],
        [0, 1, 7],
        [1, 1, 28]
      ]
    },
    disallow_kick: !0
  },
  s: {
    matrix: {
      w: 3,
      h: 3,
      dx: 1,
      dy: 1,
      data: [
        [
          [1, 0, 201],
          [2, 0, 124],
          [0, 1, 199],
          [1, 1, 156]
        ],
        [
          [2, 1, 114],
          [2, 2, 31],
          [1, 0, 241],
          [1, 1, 39]
        ],
        [
          [1, 2, 156],
          [0, 2, 199],
          [2, 1, 124],
          [1, 1, 201]
        ],
        [
          [0, 1, 39],
          [0, 0, 241],
          [1, 2, 31],
          [1, 1, 114]
        ]
      ]
    },
    preview: {
      w: 3,
      h: 2,
      data: [
        [1, 0, 201],
        [2, 0, 124],
        [0, 1, 199],
        [1, 1, 156]
      ]
    }
  },
  i: {
    matrix: {
      w: 4,
      h: 4,
      dx: 1,
      dy: 1,
      data: [
        [
          [0, 1, 199],
          [1, 1, 68],
          [2, 1, 68],
          [3, 1, 124]
        ],
        [
          [2, 0, 241],
          [2, 1, 17],
          [2, 2, 17],
          [2, 3, 31]
        ],
        [
          [3, 2, 124],
          [2, 2, 68],
          [1, 2, 68],
          [0, 2, 199]
        ],
        [
          [1, 3, 31],
          [1, 2, 17],
          [1, 1, 17],
          [1, 0, 241]
        ]
      ]
    },
    preview: {
      w: 4,
      h: 1,
      data: [
        [0, 0, 199],
        [1, 0, 68],
        [2, 0, 68],
        [3, 0, 124]
      ]
    },
    kickset_special: "i"
  },
  j: {
    matrix: {
      w: 3,
      h: 3,
      dx: 1,
      dy: 1,
      data: [
        [
          [0, 0, 241],
          [0, 1, 39],
          [1, 1, 68],
          [2, 1, 124]
        ],
        [
          [2, 0, 124],
          [1, 0, 201],
          [1, 1, 17],
          [1, 2, 31]
        ],
        [
          [2, 2, 31],
          [2, 1, 114],
          [1, 1, 68],
          [0, 1, 199]
        ],
        [
          [0, 2, 199],
          [1, 2, 156],
          [1, 1, 17],
          [1, 0, 241]
        ]
      ]
    },
    preview: {
      w: 3,
      h: 2,
      data: [
        [0, 0, 241],
        [0, 1, 39],
        [1, 1, 68],
        [2, 1, 124]
      ]
    }
  },
  t: {
    matrix: {
      w: 3,
      h: 3,
      dx: 1,
      dy: 1,
      data: [
        [
          [1, 0, 241],
          [0, 1, 199],
          [1, 1, 164],
          [2, 1, 124]
        ],
        [
          [2, 1, 124],
          [1, 0, 241],
          [1, 1, 41],
          [1, 2, 31]
        ],
        [
          [1, 2, 31],
          [2, 1, 124],
          [1, 1, 74],
          [0, 1, 199]
        ],
        [
          [0, 1, 199],
          [1, 2, 31],
          [1, 1, 146],
          [1, 0, 241]
        ]
      ]
    },
    preview: {
      w: 3,
      h: 2,
      data: [
        [1, 0, 241],
        [0, 1, 199],
        [1, 1, 164],
        [2, 1, 124]
      ]
    }
  },
  oo: {
    matrix: {
      w: 4,
      h: 4,
      dx: 1,
      dy: 1,
      data: [
        [
          [0, 1, 193],
          [1, 1, 64],
          [2, 1, 64],
          [3, 1, 112],
          [0, 2, 7],
          [1, 2, 4],
          [2, 2, 4],
          [3, 2, 28]
        ],
        [
          [2, 0, 112],
          [2, 1, 16],
          [2, 2, 16],
          [2, 3, 28],
          [1, 0, 193],
          [1, 1, 1],
          [1, 2, 1],
          [1, 3, 7]
        ],
        [
          [3, 2, 28],
          [2, 2, 68],
          [1, 2, 68],
          [0, 2, 7],
          [3, 1, 112],
          [2, 1, 64],
          [1, 1, 64],
          [0, 1, 193]
        ],
        [
          [1, 3, 7],
          [1, 2, 1],
          [1, 1, 1],
          [1, 0, 193],
          [2, 3, 28],
          [2, 2, 16],
          [2, 1, 16],
          [2, 0, 112]
        ]
      ]
    },
    preview: {
      w: 4,
      h: 2,
      data: [
        [0, 0, 193],
        [1, 0, 64],
        [2, 0, 64],
        [3, 0, 112],
        [0, 1, 7],
        [1, 1, 4],
        [2, 1, 4],
        [3, 1, 28]
      ]
    },
    kickset_special: "oo",
    weight: 1
  }
};

const DisplayCountersList = Object.keys({
  timer: "time",
  stopwatch: "time",
  level: "level",
  lines: "lines",
  allclears: "all clears",
  hold: "hold",
  pieces: "pieces",
  pieces_duo: "pieces",
  finesse_l: "finesse",
  finesse: "finesse",
  keys: "inputs",
  score: "score",
  spp: "score",
  garbage: "garbage",
  attack: "attack",
  attack_duo: "attack",
  vs: "VS score",
  kills: "KO's",
  kills_duo: "KO's",
  placement: "placement"
});

export const OptionsList = {
  version: { default: 11, static: !0 },
  gameid: { default: 0, min: 0, max: 8192, strict: !0 },
  seed: { default: 0 },
  seed_random: { default: !1 },
  score: { default: 0 },
  are: { default: 0 },
  lineclear_are: { default: 0 },
  g: { default: 0.02 },
  gincrease: { default: 0 },
  gmargin: { default: 0 },
  gravitymay20g: { default: !0 },
  shielded: { default: 0 },
  hasgarbage: { default: !1 },
  usebombs: { default: !1 },
  garbagespeed: { default: 20, integer: !0, min: 1 },
  garbagefavor: { default: 0 },
  garbagemultiplier: { default: 1 },
  receivemultiplier: { default: 1 },
  cancelmultiplier: { default: 1 },
  garbagemargin: { default: 0 },
  garbageincrease: { default: 0 },
  garbageholesize: { default: 1 },
  garbagephase: { default: 0 },
  garbagequeue: { default: !1 },
  garbageentry: {
    default: "instant",
    allowed: ["instant", "continuous", "delayed"]
  },
  garbageare: { default: 5, integer: !0, min: 1 },
  garbagearebump: { default: 12, integer: !0, min: 0 },
  garbagecap: { default: 8 },
  garbagecapincrease: { default: 0 },
  garbagecapmargin: { default: 0 },
  garbagecapmax: { default: 40 },
  garbageabsolutecap: { default: 0 },
  garbageattackcap: { default: 0 },
  garbagetargetbonus: {
    default: "none",
    allowed: ["none", "defensive", "offensive"]
  },
  garbageblocking: {
    default: "combo blocking",
    allowed: ["none", "combo blocking", "limited blocking"]
  },
  passthrough: {
    default: "zero",
    allowed: ["zero", "limited", "consistent", "full"]
  },
  openerphase: { default: 0 },
  roundmode: { default: "down", allowed: ["down", "rng"] },
  garbagespecialbonus: { default: !1 },
  spinbonuses: {
    default: "T-spins",
    allowed: [
      "none",
      "T-spins",
      "T-spins+",
      "all",
      "all+",
      "all-mini",
      "all-mini+",
      "mini-only",
      "handheld",
      "stupid"
    ]
  },
  combotable: {
    default: "multiplier",
    allowed: ["none", "multiplier", "classic guideline", "modern guideline"]
  },
  kickset: {
    default: "SRS+",
    possibles: ["none", "SRS", "SRS+", "TETRA-X", "NRS", "ARS", "ASC"]
  },
  bagtype: {
    default: "7-bag",
    allowed: [
      "total mayhem",
      "classic",
      "pairs",
      "14-bag",
      "7+1-bag",
      "7+2-bag",
      "7+x-bag",
      "7-bag+oo",
      "7+1-lone-bag",
      "14+1-lone-bag",
      "7+2-lone-bag",
      "14+2-lone-bag",
      "7-bag"
    ]
  },
  messiness_change: { default: 1 },
  messiness_inner: { default: 0 },
  messiness_nosame: { default: !1 },
  messiness_center: { default: !1 },
  messiness_timeout: { default: 0 },
  b2bchaining: { default: !1 },
  b2bcharging: { default: !1 },
  b2bextras: { default: !1 },
  b2bcharge_at: { default: 4, integer: !0, min: 0, max: 10 },
  b2bcharge_base: { default: 0, integer: !0, min: 0, max: 10 },
  allclears: { default: !0 },
  allclear_garbage: { default: 10, integer: !0, min: 0 },
  allclear_b2b: { default: 0, integer: !0, min: 0 },
  allclear_b2b_sends: { default: !1 },
  allclear_b2b_dupes: { default: !0 },
  allclear_charges: { default: !1 },
  allow_harddrop: { default: !0 },
  allow180: { default: !1 },
  infinite_hold: { default: !1 },
  infinite_movement: { default: !1 },
  nextcount: { default: 5, integer: !0, min: 1, max: 6 },
  clutch: { default: !0 },
  no_szo: { default: !1 },
  nolockout: { default: !1 },
  manual_allowed: { default: !0 },
  new_payback: { default: !1 },
  can_undo: { default: !1 },
  boardwidth: { default: 10, min: 4, max: 100 },
  boardheight: { default: 20, min: 1, max: 100 },
  boardbuffer: { default: 20, min: 0, max: 100 },
  stock: { default: 0, min: 0, max: 10 },
  infinite_stock: { default: !1 },
  locktime: { default: 30 },
  lockresets: { default: 15, min: 0, max: 30 },
  prestart: { default: 0 },
  precountdown: { default: 0 },
  countdown: { default: !1 },
  countdown_count: { default: 3 },
  countdown_interval: { default: 1e3 },
  inverted: { default: !1 },
  mission: { default: "" },
  mission_type: {
    default: "mission",
    allowed: ["mission", "mission_free", "mission_versus", "mission_league"]
  },
  no_mission_sound: { default: !1 },
  objective_type: { default: "none", allowed: ["none", "lines", "timed"] },
  objective_count: { default: 0 },
  objective_time: { default: 0 },
  objective_result: {
    default: "",
    allowed: ["", "score", "time", "lines"]
  },
  zoominto: {
    default: "none",
    allowed: ["none", "slow", "fast", "cinematic", "fade", "zenithduoleft"]
  },
  noextrawidth: { default: !1 },
  stride: { default: !1 },
  pro: { default: !1 },
  pro_alert: { default: !1 },
  pro_retry: { default: !1 },
  can_retry: { default: !1 },
  slot_counter1: { default: "", allowed: ["", ...DisplayCountersList] },
  slot_counter2: { default: "", allowed: ["", ...DisplayCountersList] },
  slot_counter3: { default: "", allowed: ["", ...DisplayCountersList] },
  slot_counter4: { default: "", allowed: ["", ...DisplayCountersList] },
  slot_counter5: { default: "", allowed: ["", ...DisplayCountersList] },
  slot_bar1: { default: "", allowed: ["", "impending", "progress"] },
  slot_bar2: { default: "", allowed: ["", "impending", "progress"] },
  absolute_lines: { default: !1 },
  display_zen: { default: !1 },
  display_username: { default: !1 },
  display_fire: { default: !1 },
  display_replay: { default: !1 },
  display_next: { default: !0 },
  display_hold: { default: !0 },
  display_shadow: { default: !0 },
  levels: { default: !1 },
  masterlevels: { default: !1 },
  startinglevel: { default: 1 },
  levelspeed: { default: 1 },
  levelstatic: { default: !1 },
  levelstaticspeed: { default: 10 },
  levelgbase: { default: 0.8 },
  levelgspeed: { default: 0.007 },
  minoskin: {
    default: {
      z: "tetrio",
      l: "tetrio",
      o: "tetrio",
      s: "tetrio",
      i: "tetrio",
      j: "tetrio",
      t: "tetrio",
      other: "tetrio",
      ghost: "tetrio"
    }
  },
  boardskin: { default: "generic", possibles: ["generic", "tetrio"] },
  map: { default: "" },
  handling: { default: {} },
  room_handling: { default: !1 },
  room_handling_arr: { default: 2 },
  room_handling_das: { default: 10 },
  room_handling_sdf: { default: 6 },
  noreplay: { default: !1 },
  nosound: { default: !1 },
  bgmnoreset: { default: !1 },
  neverstopbgm: { default: !1 },
  song: {
    default: "RANDOMcalm",
    possibles: ["none", "RANDOM", "RANDOMcalm", "RANDOMbattle"]
  },
  survivalmode: { default: "none", allowed: ["none", "layer", "timer"] },
  survival_messiness: { default: 0 },
  survival_layer_amt: { default: 10 },
  survival_layer_non: { default: !1 },
  survival_layer_min: { default: 0 },
  survival_timer_itv: { default: 1 },
  survival_cap: { default: 0 },
  invisible: { default: !1 },
  master_invisible: { default: !1 },
  void_holes: { default: 0, integer: !0, min: 0, max: 15 },
  void_holes_hungryness: { default: 12, integer: !0, min: 1 },
  tutorial: { default: !1 },
  usezenconfig: { default: !1 },
  zenlevels: { default: !1 },
  zenlevel: { default: 1 },
  zenprogress: { default: 0 },
  nosiren: { default: !1 },
  anchorseed: { default: !1 },
  forfeit_time: { default: 60 },
  username: { default: "" },
  latencymode: {
    default: "medium",
    allowed: ["zero", "low", "medium", "high", "xhigh"]
  },
  fulloffset: { default: 300 },
  fullinterval: { default: 300 },
  fromretry: { default: !1 },
  retryisclear: { default: !1 },
  topoutisclear: { default: !1 },
  zenith: { default: !1 },
  zenith_expert: { default: !1 },
  zenith_doublehole: { default: !1 },
  zenith_volatile: { default: !1 },
  zenith_gravity: { default: !1 },
  zenith_messy: { default: !1 },
  zenith_allspin: { default: !1 },
  zenith_duo: { default: !1 },
  zenith_mods: {
    default: [],
    allowed: [
      "invisible",
      "messy",
      "volatile",
      "nohold",
      "doublehole",
      "allspin",
      "gravity",
      "expert",
      "duo"
    ]
  },
  zenith_ally: { default: [] },
  zenith_allyexpert: { default: !1 },
  TEMP_zenith_rng: { default: !1 },
  TEMP_zenith_grace: { default: "" }
};
